// extracted by mini-css-extract-plugin
export default {"redditCard":"RedditSourceCard_redditCard__5sQGh"};